import React from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchNoticias } from "../hooks/fetchNoticias";
import SectionTitle from "../../../components/SectionTitle";
import NoticiasRecentes from "../../noticias/sections/NoticiasRecentes";

export default function NoticiasEvento({ idEvento }) {
  const {
    data: noticias,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["noticias", idEvento],
    queryFn: () => fetchNoticias({ idEvento }),
    enabled: !!idEvento,
  });

  if (isError) return null;

  return (
    <section>
      <SectionTitle color="infoLight">Notícias Relacionadas:</SectionTitle>
      <NoticiasRecentes
        fullSection
        noticiasSection={false}
        noticias={noticias || []}
        loadingNoticias={isLoading}
        errorNoticias={isError}
      />
    </section>
  );
}
